import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { GetHospitalService } from './service/get-hospital.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-hospital',
  templateUrl: './hospital.component.html',
  styleUrls: ['./hospital.component.scss']
})
export class HospitalComponent implements OnInit {
  color = "primary"
  mode = 'determinate';
  value: number;
  amount: number
  upload_count: any;
  hospital_name: string;
  use: number = 0;
  file_remain: any;
  countfilm: any;

  typeChart: any;
  dataChart: any;
  optionsChart: any;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };
  packageApi = `${environment.apiUrl}/upload/countfilm?hospital_id=${localStorage.getItem('hospital_id')}`;
  // packageApi = `${environment.apiUrl}/upload/countfilm?hospital_id=8ae7cb90-072f-4f33-bf97-51e1855a590f`;

  displayedColumns: string[] = ['no', 'username', 'filename', 'action', 'timstamp'];
  dataSource;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private http: HttpClient,
    private get_hos: GetHospitalService
  ) { }

  ngOnInit() {
    this.getPackage()
    this.getLog()
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getPackage() {
    this.http.get(this.packageApi, this.httpOptions).subscribe(packages => {
      console.log(packages);
      this.upload_count = packages
      this.hospital_name = this.upload_count['hospital_name']
      this.file_remain = this.upload_count['file_remain']
      this.countfilm = this.upload_count['countfilm']
      this.use = this.upload_count['use_file_amount'] - this.upload_count['file_remain']
      this.amount = (this.use / this.upload_count['use_file_amount']) * 100
      this.value = this.amount

      this.typeChart = 'pie';   ////// สามารถกำหนดเป็น 'line','bar','radar','pie','doughnut','polarArea','bubble','scatter'
      this.dataChart = {
        // labels: ["ฟิล์มคงเหลือ", "ฟิล์มที่ใช้ไป"],
        labels: ["ฟิล์มที่ใช้ไป", "ฟิล์มคงเหลือ"],
        datasets: [
          {
            label: "My Stats Chart",
            // data: [this.file_remain, this.countfilm],
            data: [this.countfilm, this.file_remain],
            backgroundColor: ['#3498db', '#bdc3c7'],
            // labelColor : ['#3498db','#3498db']
          }
        ]
      };
      this.optionsChart = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            // This more specific font property overrides the global property
            fontColor: '#000000'
          }
        }
      };

    })
  }

  getLog() {
    this.get_hos.getLogAll().subscribe(log => {
      console.log(log);
      this.dataSource = new MatTableDataSource(log);
      this.dataSource.paginator = this.paginator;
    })
  }

}
